module.exports = __webpack_public_path__ + "media/taipei/tea eggs-232790d0.jpg";